import { FC } from 'react';

import { Box, Grid, Typography } from '@mui/material';
import { isEmpty } from '@npi/buddy-utils';

import { DocumentUploadedPreview, File } from 'src/components/DocumentUploadedPreview';

type Principal = {
    firstName: string;
    lastName: string;
    personalDocuments: File[];
};
interface Principals {
    principals: Principal[];
}

export const Principals: FC<Principals> = ({ principals }) => {
    const getDocuments = (principal: Principal) => {
        const documents = principal.personalDocuments.filter((el) => {
            return !isEmpty(el) && el?.url;
        });

        if (documents.length) {
            return documents.map((file) => {
                return (
                    <DocumentUploadedPreview
                        file={file}
                        key={file.fileName}
                        boxProps={{ width: '49%' }}
                    />
                );
            });
        }
        return <Typography>No Documents have been uploaded</Typography>;
    };

    return (
        <Box display="flex" flexDirection="column" gap="16px">
            {principals.length ? (
                principals.map((principal, index) => {
                    return (
                        <Box key={index}>
                            <Typography
                                fontSize="24px"
                                fontWeight="500"
                                color="#434341"
                                lineHeight="36px"
                            >
                                {`Principal ${index + 1} - ${principal.firstName} ${
                                    principal.lastName
                                }`}
                            </Typography>
                            <Box height="1px" bgcolor="#F3A256" width="100%" marginY="8px" />
                            <Typography
                                fontSize="20px"
                                lineHeight="28px"
                                fontWeight="500"
                                color="#1d1d1b"
                                marginBottom="32px"
                            >
                                Personal Documents
                            </Typography>
                            <Grid container rowSpacing={1} columns={2} gap="8px">
                                {getDocuments(principal)}
                            </Grid>
                        </Box>
                    );
                })
            ) : (
                <Typography fontSize="24px" color="#1D1D1B" marginBottom="8px">
                    No Beneficial Owners
                </Typography>
            )}
        </Box>
    );
};
